import { AxiosResponse } from 'axios';

import { loginApi } from '../../setup/setupApi';
import { EmailProvider, SMSProviderValues } from './types';

export const getSMSProvidersList = (projectId: string): Promise<SMSProviderValues[]> =>
  loginApi.get(`projects/${projectId}/sms_provider`).then((res) => res.data);

export const getSMSProvider = (
  projectId: string,
  providerName: string
): Promise<SMSProviderValues> =>
  loginApi.get(`projects/${projectId}/sms_provider/${providerName}`).then((res) => res.data);

export const setSMSProviders = (
  projectId: string,
  values: SMSProviderValues
): Promise<SMSProviderValues[]> =>
  loginApi
    .post<SMSProviderValues, AxiosResponse<SMSProviderValues[]>>(
      `projects/${projectId}/sms_provider`,
      values
    )
    .then((res) => res.data);

export const updateSMSProvider = (
  projectId: string,
  values: SMSProviderValues,
  name: string,
  updateSecret?: boolean
): Promise<SMSProviderValues> =>
  loginApi
    .put(`projects/${projectId}/sms_provider/${name}`, values, {
      params: {
        update_secret: !!updateSecret
      }
    })
    .then((res) => res.data);

export const deleteSMSProvider = (projectId: string, providerName: string): Promise<boolean> =>
  loginApi.delete(`projects/${projectId}/sms_provider/${providerName}`).then((res) => res.data);

export const getEmailProvider = (projectId: string): Promise<EmailProvider> =>
  loginApi.get(`projects/${projectId}/email_provider`).then((res) => res.data);

export const putEmailProvider = (projectId: string, data: EmailProvider): Promise<EmailProvider> =>
  loginApi.put(`projects/${projectId}/email_provider`, data).then((res) => res.data);
